export default __webpack_public_path__ + "static/media/DEED-1.2cdab835.jpg";